import * as React from "react";
const ResCross = (props) => (
  <svg
    width={16}
    height={15}
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={1.44824} y={0.5} width={14} height={14} rx={7} stroke="#B72000" />
    <path
      d="M10.556 5.26855L6.33887 9.7314"
      stroke="#B72000"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M6.33953 5.26855L10.5566 9.7314"
      stroke="#B72000"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
export default ResCross;
